module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#rnotetothereader"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Note to the Reader")])])]), _vm._v(" "), _c('div', {
    staticClass: "open"
  }, [_vm._v("My husband, Thomas F. Walsh, died on November 2, 1991, while this book was passing through the press. He had corrected and returned the galleys, and then made some subsequent corrections, and these were entered on the page proofs, which have been read and corrected by a group of my husband’s colleagues: Roland Flint, Philip Herzbrun, John Hirsh, Raymond Reno, Eusebio Rodrigues, Jason Rosenblatt, and Roger Slakey. The index was prepared by our friend Beth Alvarez, herself an accomplished student of Katherine Anne Porter, who also assisted with the proofreading. This book is my husband’s masterwork, the culmination of many years’ work on Katherine Anne Porter and on Mexico, and I am most grateful to all who helped bring it to completion.")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("Maria A. Walsh"), _c('br'), _vm._v("January 19, 1992")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c27fca5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notetothereader.vue
// module id = 75
// module chunks = 0